// extracted by mini-css-extract-plugin
export var alertIcon = "_sf-0";